<!-- <p>risk-view-analyticss works!</p> -->
<div class="container">
  <section class="overall-section">
    <h2 class="section-title">📊 Monthly Performance Overview</h2>
    <mat-card class="performance-card">
      <mat-card-title>Monthly Analytics Data</mat-card-title>
      <mat-grid-list [cols]="screenSize == ScreenType.Mobile ? 1 : 2" rowHeight="150px" gutterSize="16px">
        <mat-grid-tile *ngFor="let score of riskScorsIndicators">
          <mat-card [ngClass]="getClass(score.label)" class="indicator-box">
            <div class="box-header">
              <span>{{ score.label }}</span>
              <!-- <mat-icon>{{ getIcon(score.label) }}</mat-icon> -->
            </div>
            <div class="value">{{ score.value }}</div>
            <!-- <div class="trend" [ngClass]="cat.trendDirection">
              {{ cat.trend }}%
              <mat-icon *ngIf="cat.trendDirection === 'up'">arrow_upward</mat-icon>
              <mat-icon *ngIf="cat.trendDirection === 'down'">arrow_downward</mat-icon>
              <mat-icon *ngIf="cat.trendDirection === 'neutral'">remove</mat-icon>
            </div> -->
            <div class="subtext" *ngIf="score.subtext">{{ score.subtext }}</div>
          </mat-card>
        </mat-grid-tile>
      </mat-grid-list>
    </mat-card>

    <!-- <mat-card class="chart-card">
      <mat-card-title>Day Risk Score</mat-card-title>
      <app-risk-bar-graph *ngIf="riskSingleData?.length > 0" [chartHeight]="500"
        [chartData]="riskSingleData"></app-risk-bar-graph>
      <div *ngIf="riskSingleData?.length == 0" class="no-data-available">
        No Data Available
      </div>
    </mat-card> -->
  </section>

  <br />
  <mat-divider></mat-divider>
  <br />

  <section class="incident-section">
    <h2 class="section-title">⚠️ Incident Risk Analytics</h2>

    <mat-card class="performance-card">
      <mat-card-title>Incident Analytics Data</mat-card-title>
      <mat-grid-list [cols]="screenSize == ScreenType.Mobile ? 1 : 2" rowHeight="130px" gutterSize="16px">
        <!-- <mat-grid-tile *ngFor="let score of riskScorsIndicators"> -->
        <mat-grid-tile>
          <mat-card [ngClass]="getClass('')" class="indicator-box">
            <div class="box-header">
              <span>Total Incidents</span>
              <!-- <mat-icon>{{ getIcon(score.label) }}</mat-icon> -->
            </div>
            <div class="value">{{incidentAnalytics.totalIncidents}}</div>
          </mat-card>
        </mat-grid-tile>
        <mat-grid-tile>
          <mat-card [ngClass]="getClass('')" class="indicator-box">
            <div class="box-header">
              <span>Open To Close Time Ratio</span>
              <!-- <mat-icon>{{ getIcon(score.label) }}</mat-icon> -->
            </div>
            <div class="value">{{incidentAnalytics.openToCloseTimeRatio | number : '1.2-2'}}</div>
          </mat-card>
        </mat-grid-tile>
        <mat-grid-tile>
          <mat-card [ngClass]="getClass('')" class="indicator-box">
            <div class="box-header">
              <span>Critical To Medium Ratio</span>
              <!-- <mat-icon>{{ getIcon(score.label) }}</mat-icon> -->
            </div>
            <div class="value">{{incidentAnalytics.criticalToMedium | number : '1.2-2'}}</div>
          </mat-card>
        </mat-grid-tile>
        <mat-grid-tile>
          <mat-card [ngClass]="getClass('')" class="indicator-box">
            <div class="box-header">
              <span>Critical To Low Ratio</span>
              <!-- <mat-icon>{{ getIcon(score.label) }}</mat-icon> -->
            </div>
            <div class="value">{{incidentAnalytics.criticalToLow | number : '1.2-2'}}</div>
          </mat-card>
        </mat-grid-tile>

        <!-- <mat-grid-tile *ngFor="let transition of transitionKeys">
          <mat-card [ngClass]="getClass('')" class="indicator-box">
            <div class="box-header">
              <span>{{ transition }}</span>
            </div>
            <div class="value">
              Count: {{ incidentAnalytics.transitionMatrix[transition].item1 }}
            </div>
            <div class="subtext">
              Percent: {{ incidentAnalytics.transitionMatrix[transition].item2 | number: '1.2-2' }}%
            </div>
          </mat-card>
        </mat-grid-tile> -->

      </mat-grid-list>

      <!-- <mat-grid-list cols="3" rowHeight="fit">
        <mat-grid-tile *ngFor="let transition of transitionKeys">
          <mat-card [ngClass]="getClass('')" class="indicator-box">
            <div class="box-header">
              <span>{{ transition }}</span>
            </div>
            <div class="value">
              Count: {{ incidentAnalytics.transitionMatrix[transition].item1 }}
            </div>
            <div class="value">
              Percent: {{ incidentAnalytics.transitionMatrix[transition].item2 | number: '1.2-2' }}%
            </div>
          </mat-card>
        </mat-grid-tile>
      </mat-grid-list> -->
    </mat-card>

    <!-- <div class="incident-card-container">
      <mat-card class="chart-card status-data">
        <mat-card-title>Risk Status Data</mat-card-title>
        <app-risk-breakdown-graph *ngIf="riskAnalyticsStatusGraph?.length != null" [chartHeight]="385"
          [breakdownRiskData]="riskAnalyticsStatusGraph"></app-risk-breakdown-graph>
        <div *ngIf="riskAnalyticsStatusGraph?.length == null" class="no-data-available">
          No Data Available
        </div>
      </mat-card>

      <mat-card class="chart-card score-breakdown">
        <mat-card-title>Risk Score Breakdown</mat-card-title>
        <app-risk-pie-graph [chartHeight]="300" [chartData]="criticalIncidentsData"></app-risk-pie-graph>
      </mat-card>
    </div> -->

    <mat-card class="chart-card">
      <!-- <mat-card-title>Risk Trend Over Time</mat-card-title> -->
      <div style="display: flex; justify-content: space-between; align-items: center;">
        <mat-card-title>Incident Status Counts</mat-card-title>
        <div>
          <button mat-button (click)="onRangeChange('1d', 'IncidentStatusCounts')">1 Day</button>
          <button mat-button (click)="onRangeChange('1w', 'IncidentStatusCounts')">1 Week</button>
          <button mat-button (click)="onRangeChange('1m', 'IncidentStatusCounts')">1 Month</button>
          <!-- <button mat-button (click)="onRangeChange('1y', 'IncidentStatusCounts')">1 Year</button> -->
        </div>
      </div>
      <app-smooth-line-chart [RiskTrendData]="incidentStatusCountsChart"></app-smooth-line-chart>
    </mat-card>

    <mat-card class="chart-card">
      <!-- <mat-card-title>Risk Trend Over Time</mat-card-title> -->
      <div style="display: flex; justify-content: space-between; align-items: center;">
        <mat-card-title>Incidents by categories</mat-card-title>
        <div>
          <button mat-button (click)="onRangeChange('1d', 'IncidentsByCategories')">1 Day</button>
          <button mat-button (click)="onRangeChange('1w', 'IncidentsByCategories')">1 Week</button>
          <button mat-button (click)="onRangeChange('1m', 'IncidentsByCategories')">1 Month</button>
          <!-- <button mat-button (click)="onRangeChange('1y')">1 Year</button> -->
        </div>
      </div>
      <app-smooth-line-chart [RiskTrendData]="incidentsCategoriesCountChart"></app-smooth-line-chart>
    </mat-card>

    <mat-card class="chart-card">
      <!-- <mat-card-title>Risk Trend Over Time</mat-card-title> -->
      <div style="display: flex; justify-content: space-between; align-items: center;">
        <mat-card-title>Average Time Chart</mat-card-title>
        <div>
          <!-- <button mat-button (click)="onRangeChange('1d', 'AverageTimeChart')">1 Day</button>
          <button mat-button (click)="onRangeChange('1w', 'AverageTimeChart')">1 Week</button>
          <button mat-button (click)="onRangeChange('1m', 'AverageTimeChart')">1 Month</button> -->
          <!-- <button mat-button (click)="onRangeChange('1y')">1 Year</button> -->
        </div>
      </div>
      <app-smooth-line-chart [RiskTrendData]="AverageTimeChart"></app-smooth-line-chart>
    </mat-card>

    <mat-card class="chart-card">
      <!-- <mat-card-title>Risk Trend Over Time</mat-card-title> -->
      <div style="display: flex; justify-content: space-between; align-items: center;">
        <mat-card-title>Resolution Rate Chart</mat-card-title>
        <div>
          <button mat-button (click)="onRangeChange('1d', 'ResolutionRateChart')">1 Day</button>
          <button mat-button (click)="onRangeChange('1w', 'ResolutionRateChart')">1 Week</button>
          <button mat-button (click)="onRangeChange('1m', 'ResolutionRateChart')">1 Month</button>
          <!-- <button mat-button (click)="onRangeChange('1y')">1 Year</button> -->
        </div>
      </div>
      <app-smooth-line-chart [RiskTrendData]="ResolutionRateChart"></app-smooth-line-chart>
    </mat-card>

    <mat-card class="chart-card">
      <!-- <mat-card-title>Risk Trend Over Time</mat-card-title> -->
      <div style="display: flex; justify-content: space-between; align-items: center;">
        <mat-card-title>Transition Matrix Chart</mat-card-title>
        <!-- <div>
          <button mat-button (click)="onRangeChange('1d')">1 Day</button>
          <button mat-button (click)="onRangeChange('1w')">1 Week</button>
          <button mat-button (click)="onRangeChange('1m')">1 Month</button>
          <button mat-button (click)="onRangeChange('1y')">1 Year</button>
        </div> -->
      </div>
      <app-smooth-line-chart [RiskTrendData]="transitionMatrixChart"></app-smooth-line-chart>
    </mat-card>

    <mat-card class="chart-card">
      <!-- <mat-card-title>Risk Trend Over Time</mat-card-title> -->
      <div style="display: flex; justify-content: space-between; align-items: center;">
        <mat-card-title>INCIDENT BREAKDOWN</mat-card-title>
        <div>
          <!-- <button mat-button (click)="onRangeChange('1d')">1 Day</button>
          <button mat-button (click)="onRangeChange('1w')">1 Week</button>
          <button mat-button (click)="onRangeChange('1m')">1 Month</button> -->
          <!-- <button mat-button (click)="onRangeChange('1y')">1 Year</button> -->
        </div>
      </div>
      <!-- <app-smooth-line-chart [RiskTrendData]="AverageTimeChart"></app-smooth-line-chart> -->
      <app-incident-breakdown [breakdownIncidentData]="breakdownGraphData"></app-incident-breakdown>
    </mat-card>

    <mat-card class="chart-card">
      <!-- <mat-card-title>Risk Trend Over Time</mat-card-title> -->
      <div style="display: flex; justify-content: space-between; align-items: center;">
        <mat-card-title>INCIDENT STATUS</mat-card-title>
        <div>
          <!-- <button mat-button (click)="onRangeChange('1d')">1 Day</button>
          <button mat-button (click)="onRangeChange('1w')">1 Week</button>
          <button mat-button (click)="onRangeChange('1m')">1 Month</button> -->
          <!-- <button mat-button (click)="onRangeChange('1y')">1 Year</button> -->
        </div>
      </div>
      <!-- <app-smooth-line-chart [RiskTrendData]="AverageTimeChart"></app-smooth-line-chart> -->
      <app-incident-status-graph [graphIncidentData]="incidentGraphCounts"></app-incident-status-graph>
    </mat-card>

  </section>

  <br />
  <mat-divider></mat-divider>
  <br />

  <section class="visitor-section">
    <h2 class="section-title">👥 Visitor Analytics</h2>

    <div class="visitor-card-container">
      <mat-card class="chart-card categories-breakdown">
        <mat-card-title>Visitor Category Breakdown</mat-card-title>
        <app-visitor-category-pie [chartHeight]="300" [chartData]="monthlyVisitorCategory"></app-visitor-category-pie>
      </mat-card>

      <mat-card class="chart-card in-out-bandwidth">
        <mat-card-title>Inbound/Outbound Bandwidth</mat-card-title>
        <app-visitor-in-out-bound [chartHeight]="285"
          [visitorInOutGraphDetails]="monthlyVisitorInOutGraph"></app-visitor-in-out-bound>
      </mat-card>
    </div>

    <mat-card class="chart-card">
      <mat-card-title>Monthly Visitors</mat-card-title>
      <app-visitor-bar-graph [chartHeight]="300" [chartData]="monthlyVisitorBarGraph"></app-visitor-bar-graph>
      <!-- <div *ngIf="riskSingleData?.length == 0" class="no-data-available">
        No Data Available
      </div> -->
    </mat-card>

    <mat-card class="chart-card">
      <!-- <mat-card-title>Risk Trend Over Time</mat-card-title> -->
      <div style="display: flex; justify-content: space-between; align-items: center;">
        <mat-card-title>Visitor</mat-card-title>
        <div>
          <button mat-button (click)="onRangeChange('1d', 'Visitors')">1 Day</button>
          <button mat-button (click)="onRangeChange('1w', 'Visitors')">1 Week</button>
          <button mat-button (click)="onRangeChange('1m', 'Visitors')">1 Month</button>
          <!-- <button mat-button (click)="onRangeChange('1y', 'Visitors')">1 Year</button> -->
        </div>
      </div>
      <app-smooth-line-chart [RiskTrendData]="getRepeatingVisitors"></app-smooth-line-chart>
    </mat-card>

    <mat-card class="chart-card">
      <div style="display: flex; justify-content: space-between; align-items: center;">
        <mat-card-title>Visitor CheckIn/CheckOut Ratio</mat-card-title>
        <div>
          <button mat-button (click)="onRangeChange('1d', 'CheckInToCheckOutRatio')">1 Day</button>
          <button mat-button (click)="onRangeChange('1w', 'CheckInToCheckOutRatio')">1 Week</button>
          <button mat-button (click)="onRangeChange('1m', 'CheckInToCheckOutRatio')">1 Month</button>
        </div>
      </div>
      <app-smooth-line-chart [RiskTrendData]="getCheckInToCheckOutRatio"></app-smooth-line-chart>
    </mat-card>
    <mat-card class="chart-card">
      <div style="display: flex; justify-content: space-between; align-items: center;">
        <mat-card-title>VISITOR BREAKDOWN</mat-card-title>
        <div>
          <button mat-button (click)="onRangeChange('1d', 'visitorStatisticsData')">1 Day</button>
          <button mat-button (click)="onRangeChange('1w', 'visitorStatisticsData')">1 Week</button>
          <button mat-button (click)="onRangeChange('1m', 'visitorStatisticsData')">1 Month</button>
        </div>
      </div>
      <app-smooth-line-chart [RiskTrendData]="visitorStatisticsData"></app-smooth-line-chart>
    </mat-card>
  </section>

  <br />
  <mat-divider></mat-divider>
  <br />
  <!-- <section>
    <mat-card class="chart-card">
      <mat-card-title>Risk Score Breakdown</mat-card-title>
      <app-risk-pie-graph [chartHeight]="300" [chartData]="criticalIncidentsData"></app-risk-pie-graph>
    </mat-card>
  </section> -->
  <section class="incident-section">
    <h2 class="section-title">⚠️ Booking</h2>
    <mat-card class="chart-card">
      <div style="display: flex; justify-content: space-between; align-items: center;">
        <mat-card-title>Booking By Assets</mat-card-title>
        <div>
          <button mat-button (click)="onRangeChange('1d', 'BookingByAssets')">1 Day</button>
          <button mat-button (click)="onRangeChange('1w', 'BookingByAssets')">1 Week</button>
          <button mat-button (click)="onRangeChange('1m', 'BookingByAssets')">1 Month</button>
        </div>
      </div>
      <app-smooth-line-chart [RiskTrendData]="getBookingByAssets"></app-smooth-line-chart>
    </mat-card>
    <mat-card class="chart-card">
      <div style="display: flex; justify-content: space-between; align-items: center;">
        <mat-card-title>Booking By Dates</mat-card-title>
        <div>
          <button mat-button (click)="onRangeChange('1d', 'BookingByDates')">1 Day</button>
          <button mat-button (click)="onRangeChange('1w', 'BookingByDates')">1 Week</button>
          <button mat-button (click)="onRangeChange('1m', 'BookingByDates')">1 Month</button>
        </div>
      </div>
      <app-smooth-line-chart [RiskTrendData]="getBookingByDates"></app-smooth-line-chart>
    </mat-card>
    <mat-card class="chart-card">
      <div style="display: flex; justify-content: space-between; align-items: center;">
        <mat-card-title>Booking By Events</mat-card-title>
        <div>
          <button mat-button (click)="onRangeChange('1d', 'BookingByDates')">1 Day</button>
          <button mat-button (click)="onRangeChange('1w', 'BookingByDates')">1 Week</button>
          <button mat-button (click)="onRangeChange('1m', 'BookingByDates')">1 Month</button>
        </div>
      </div>
      <app-smooth-line-chart [RiskTrendData]=""></app-smooth-line-chart>
    </mat-card>
  </section>

  <br />
  <mat-divider></mat-divider>
  <br />

  <section class="incident-section">
    <h2 class="section-title">⚠️ Events</h2>
    <mat-card class="chart-card">
      <div style="display: flex; justify-content: space-between; align-items: center;">
        <mat-card-title>Events</mat-card-title>
        <div>
          <button mat-button (click)="onRangeChange('1d', 'BookingByDates')">1 Day</button>
          <button mat-button (click)="onRangeChange('1w', 'BookingByDates')">1 Week</button>
          <button mat-button (click)="onRangeChange('1m', 'BookingByDates')">1 Month</button>
        </div>
      </div>
      <app-smooth-line-chart [RiskTrendData]="totalEventChart"></app-smooth-line-chart>
    </mat-card>

    <mat-card class="chart-card">
      <div style="display: flex; justify-content: space-between; align-items: center;">
        <mat-card-title>Visitor Per Event</mat-card-title>
        <div>
          <button mat-button (click)="onRangeChange('1d', 'BookingByDates')">1 Day</button>
          <button mat-button (click)="onRangeChange('1w', 'BookingByDates')">1 Week</button>
          <button mat-button (click)="onRangeChange('1m', 'BookingByDates')">1 Month</button>
        </div>
      </div>
      <app-smooth-line-chart [RiskTrendData]="getVisitorPerEventChart"></app-smooth-line-chart>
    </mat-card>

    <mat-card class="chart-card">
      <div style="display: flex; justify-content: space-between; align-items: center;">
        <mat-card-title>Visitor Attented Ratio</mat-card-title>
        <div>
          <button mat-button (click)="onRangeChange('1d', 'BookingByDates')">1 Day</button>
          <button mat-button (click)="onRangeChange('1w', 'BookingByDates')">1 Week</button>
          <button mat-button (click)="onRangeChange('1m', 'BookingByDates')">1 Month</button>
        </div>
      </div>
      <app-smooth-line-chart [RiskTrendData]="getVisitorAttendedRatioChart"></app-smooth-line-chart>
    </mat-card>
  </section>
  
  <br />
  <mat-divider></mat-divider>
  <br />

  <section class="incident-section">
    <h2 class="section-title">⚠️ Animal</h2>
    <mat-card class="chart-card">
      <div style="display: flex; justify-content: space-between; align-items: center;">
        <mat-card-title>Food Consumption</mat-card-title>
        <div>
          <button mat-button (click)="onRangeChange('1d', 'BookingByDates')">1 Day</button>
          <button mat-button (click)="onRangeChange('1w', 'BookingByDates')">1 Week</button>
          <button mat-button (click)="onRangeChange('1m', 'BookingByDates')">1 Month</button>
        </div>
      </div>
      <app-smooth-line-chart [RiskTrendData]="getAnimalFoodConsumptionChart"></app-smooth-line-chart>
    </mat-card>

    <mat-card class="chart-card">
      <div style="display: flex; justify-content: space-between; align-items: center;">
        <mat-card-title>Cost Of Maintenance</mat-card-title>
        <div>
          <button mat-button (click)="onRangeChange('1d', 'BookingByDates')">1 Day</button>
          <button mat-button (click)="onRangeChange('1w', 'BookingByDates')">1 Week</button>
          <button mat-button (click)="onRangeChange('1m', 'BookingByDates')">1 Month</button>
        </div>
      </div>
      <app-smooth-line-chart [RiskTrendData]="getCostMaintenanceChart"></app-smooth-line-chart>
    </mat-card>

    <!-- <mat-card class="chart-card">
      <div style="display: flex; justify-content: space-between; align-items: center;">
        <mat-card-title>Health Stat</mat-card-title>
        <div>
          <button mat-button (click)="onRangeChange('1d', 'BookingByDates')">1 Day</button>
          <button mat-button (click)="onRangeChange('1w', 'BookingByDates')">1 Week</button>
          <button mat-button (click)="onRangeChange('1m', 'BookingByDates')">1 Month</button>
        </div>
      </div>
      <app-smooth-line-chart [RiskTrendData]=""></app-smooth-line-chart>
    </mat-card> -->
  </section>
  
  <!-- <br />
  <mat-divider></mat-divider>
  <br />
  
  <section class="incident-section">
    <h2 class="section-title">⚠️ Inventory</h2>
    <mat-card class="chart-card">
      <div style="display: flex; justify-content: space-between; align-items: center;">
        <mat-card-title>Inventory Breakdown</mat-card-title>
        <div>
          <button mat-button (click)="onRangeChange('1d', 'BookingByDates')">1 Day</button>
          <button mat-button (click)="onRangeChange('1w', 'BookingByDates')">1 Week</button>
          <button mat-button (click)="onRangeChange('1m', 'BookingByDates')">1 Month</button>
        </div>
      </div>
      <app-smooth-line-chart [RiskTrendData]=""></app-smooth-line-chart>
    </mat-card>

    <mat-card class="chart-card">
      <div style="display: flex; justify-content: space-between; align-items: center;">
        <mat-card-title>Inventory Consumption</mat-card-title>
        <div>
          <button mat-button (click)="onRangeChange('1d', 'BookingByDates')">1 Day</button>
          <button mat-button (click)="onRangeChange('1w', 'BookingByDates')">1 Week</button>
          <button mat-button (click)="onRangeChange('1m', 'BookingByDates')">1 Month</button>
        </div>
      </div>
      <app-smooth-line-chart [RiskTrendData]=""></app-smooth-line-chart>
    </mat-card>
  </section> -->
  
  <br />
  <mat-divider></mat-divider>
  <br />
  
  <section class="incident-section">
    <h2 class="section-title">⚠️ Assets</h2>
    <mat-card class="chart-card">
      <div style="display: flex; justify-content: space-between; align-items: center;">
        <mat-card-title>Power Consumption</mat-card-title>
        <div>
          <button mat-button (click)="onRangeChange('1d', 'BookingByDates')">1 Day</button>
          <button mat-button (click)="onRangeChange('1w', 'BookingByDates')">1 Week</button>
          <button mat-button (click)="onRangeChange('1m', 'BookingByDates')">1 Month</button>
        </div>
      </div>
      <app-smooth-line-chart [RiskTrendData]="getPowerConsumptionChart"></app-smooth-line-chart>
    </mat-card>
    
    <mat-card class="chart-card">
      <div style="display: flex; justify-content: space-between; align-items: center;">
        <mat-card-title>Property Power Consumption</mat-card-title>
        <div>
          <button mat-button (click)="onRangeChange('1d', 'BookingByDates')">1 Day</button>
          <button mat-button (click)="onRangeChange('1w', 'BookingByDates')">1 Week</button>
          <button mat-button (click)="onRangeChange('1m', 'BookingByDates')">1 Month</button>
        </div>
      </div>
      <app-smooth-line-chart [RiskTrendData]="getPropertyPowerConsumptionChart"></app-smooth-line-chart>
    </mat-card>
    
    <mat-card class="chart-card">
      <div style="display: flex; justify-content: space-between; align-items: center;">
        <mat-card-title>Property Temprature</mat-card-title>
        <div>
          <button mat-button (click)="onRangeChange('1d', 'BookingByDates')">1 Day</button>
          <button mat-button (click)="onRangeChange('1w', 'BookingByDates')">1 Week</button>
          <button mat-button (click)="onRangeChange('1m', 'BookingByDates')">1 Month</button>
        </div>
      </div>
      <app-smooth-line-chart [RiskTrendData]="getPropertyTemperature"></app-smooth-line-chart>
    </mat-card>
  </section>
</div>

<!-- <div [ngClass]="{
    'risk-analytics-container':
      screenSize == ScreenType.Desktop || screenSize == ScreenType.Tablet,
    'risk-analytics-container-mobile': screenSize == ScreenType.Mobile
  }"> -->

<!-- <section>
    <mat-grid-list [cols]="screenSize == ScreenType.Mobile ? 1 : 2" rowHeight="120px"><mat-grid-tile rowspan="3">
        <div [ngClass]="{
            'risk-analytics-counters':
              screenSize == ScreenType.Desktop ||
              screenSize == ScreenType.Tablet,
            'risk-analytics-counters-mobile': screenSize == ScreenType.Mobile
          }">
          <mat-grid-list cols="3" rowHeight="90px">
            <mat-grid-tile colspan="3">
              <div [ngClass]="{
                  'risk-analytics-counter-values':
                    screenSize == ScreenType.Desktop ||
                    screenSize == ScreenType.Tablet,
                  'risk-analytics-counter-values-mobile':
                    screenSize == ScreenType.Mobile
                }">
                <div>
                  <h2>{{ "Monthly Risk Score" | uppercase }}</h2>
                  <h4>Risk score of current month</h4>
                </div>
                <div>
                  <strong>
                    <h1 *ngIf="!isDisableFeature">
                      {{ currentMonthRiskScore
                      }}<span><b><mat-icon style="color: red" *ngIf="
                              currentMonthRiskScore >= previousMonthRiskScore
                            ">arrow_upward</mat-icon><mat-icon style="color: green" *ngIf="
                              currentMonthRiskScore < previousMonthRiskScore
                            ">arrow_downward</mat-icon>
                          <span style="font-size: 10px">
                            {{ percentageChange | number : "1.2-2" }}%
                          </span>
                        </b></span>
                    </h1>
                    <h5 *ngIf="isDisableFeature">
                      Subscribe to avail this feature
                    </h5>
                  </strong>
                </div>
              </div>
            </mat-grid-tile>
            <mat-grid-tile colspan="3">
              <div [ngClass]="{
                  'risk-analytics-counter-values':
                    screenSize == ScreenType.Desktop ||
                    screenSize == ScreenType.Tablet,
                  'risk-analytics-counter-values-mobile':
                    screenSize == ScreenType.Mobile
                }">
                <div>
                  <h2>{{ "Average Closing Time" | uppercase }}</h2>
                  <h4>Average time for an incident to close</h4>
                </div>
                <div>
                  <strong>
                    <h1>
                      {{
                      averageCloseTime == null
                      ? "NA"
                      : averageCloseTime + " mins"
                      }}
                    </h1>
                  </strong>
                </div>
              </div>
            </mat-grid-tile>
            <mat-grid-tile colspan="3">
              <div [ngClass]="{
                  'risk-analytics-counter-values':
                    screenSize == ScreenType.Desktop ||
                    screenSize == ScreenType.Tablet,
                  'risk-analytics-counter-values-mobile':
                    screenSize == ScreenType.Mobile
                }">
                <div>
                  <h2>{{ "Critical Incident Count" | uppercase }}</h2>
                  <h4>Total critical incident reported</h4>
                </div>
                <div>
                  <strong>
                    <h1 *ngIf="!isDisableFeature">
                      {{
                      criticalIncidentsCountNumber?.emergencySos +
                      criticalIncidentsCountNumber?.fire +
                      criticalIncidentsCountNumber?.intrusions +
                      criticalIncidentsCountNumber?.manual
                      }}
                    </h1>
                    <h5 *ngIf="isDisableFeature">
                      Subscribe to avail this feature
                    </h5>
                  </strong>
                </div>
              </div>
            </mat-grid-tile>
            <mat-grid-tile colspan="3">
              <div [ngClass]="{
                  'risk-analytics-counter-values':
                    screenSize == ScreenType.Desktop ||
                    screenSize == ScreenType.Tablet,
                  'risk-analytics-counter-values-mobile':
                    screenSize == ScreenType.Mobile
                }">
                <div>
                  <h2>{{ "Critical Risk Hour" | uppercase }}</h2>
                  <h4>Most active Time Span</h4>
                </div>
                <div>
                  <strong>
                    <h1 *ngIf="!isDisableFeature">
                      {{ criticalRiskHour }}
                    </h1>
                    <h5 *ngIf="isDisableFeature">
                      Subscribe to avail this feature
                    </h5>
                  </strong>
                </div>
              </div>
            </mat-grid-tile>
          </mat-grid-list>
        </div>
      </mat-grid-tile><mat-grid-tile rowspan="3" *ngIf="!isHide">
        <div [ngClass]="{
            'risk-analytics-counters':
              screenSize == ScreenType.Desktop ||
              screenSize == ScreenType.Tablet,
            'risk-analytics-counters-mobile': screenSize == ScreenType.Mobile
          }">
          <mat-grid-list cols="3" rowHeight="72px">
            <mat-grid-tile colspan="3">
              <div [ngClass]="{
                  'visitor-analytics-counter-values':
                    screenSize == ScreenType.Desktop ||
                    screenSize == ScreenType.Tablet,
                  'visitor-analytics-counter-values-mobile':
                    screenSize == ScreenType.Mobile
                }">
                <div>
                  <h2>{{ "Total Claims" | uppercase }}</h2>
                  <h4>Total claim requests for the month</h4>
                </div>
                <div>
                  <strong>
                    <h1 *ngIf="!isDisableFeature">
                      {{ currentMonthClaimTotal
                      }}<span><b><mat-icon style="color: red" *ngIf="
                              currentMonthClaimTotal >= previousMonthClaimTotal
                            ">arrow_upward</mat-icon><mat-icon style="color: green" *ngIf="
                              currentMonthClaimTotal < previousMonthClaimTotal
                            ">arrow_downward</mat-icon>
                          <span style="font-size: 10px">
                            {{ currentMonthClaimTotal | number : "1.2-2" }}%
                          </span>
                        </b></span>
                    </h1>
                    <h5 *ngIf="isDisableFeature">
                      Subscribe to avail this feature
                    </h5>
                  </strong>
                </div>
              </div>
            </mat-grid-tile>
            <mat-grid-tile colspan="3">
              <div [ngClass]="{
                  'visitor-analytics-counter-values':
                    screenSize == ScreenType.Desktop ||
                    screenSize == ScreenType.Tablet,
                  'visitor-analytics-counter-values-mobile':
                    screenSize == ScreenType.Mobile
                }">
                <div>
                  <h2>{{ "Total Claims Amount" | uppercase }}</h2>
                  <h4>Total claim amount for this month</h4>
                </div>
                <div>
                  <strong>
                    <h1 *ngIf="!isDisableFeature">
                      {{ currentMonthClaimAmount
                      }}<span><b><mat-icon style="color: red" *ngIf="
                              currentMonthClaimAmount >= previousMonthClaimTotal
                            ">arrow_upward</mat-icon><mat-icon style="color: green" *ngIf="
                              currentMonthClaimAmount < previousMonthClaimTotal
                            ">arrow_downward</mat-icon>
                          <span style="font-size: 10px">
                            {{
                            percentageChangeClaimNumber | number : "1.2-2"
                            }}%
                          </span>
                        </b></span>
                    </h1>
                    <h5 *ngIf="isDisableFeature">
                      Subscribe to avail this feature
                    </h5>
                  </strong>
                </div>
              </div>
            </mat-grid-tile>
            <mat-grid-tile colspan="3">
              <div [ngClass]="{
                  'visitor-analytics-counter-values':
                    screenSize == ScreenType.Desktop ||
                    screenSize == ScreenType.Tablet,
                  'visitor-analytics-counter-values-mobile':
                    screenSize == ScreenType.Mobile
                }">
                <div>
                  <h2>{{ "Unique Visitor" | uppercase }}</h2>
                  <h4>Visitors in the current month</h4>
                </div>
                <div>
                  <strong>
                    <h2>{{ uniqueVisitors }}</h2>
                  </strong>
                </div>
              </div>
            </mat-grid-tile>
            <mat-grid-tile colspan="3">
              <div [ngClass]="{
                  'visitor-analytics-counter-values':
                    screenSize == ScreenType.Desktop ||
                    screenSize == ScreenType.Tablet,
                  'visitor-analytics-counter-values-mobile':
                    screenSize == ScreenType.Mobile
                }">
                <div>
                  <h2>{{ "Hot Hour" | uppercase }}</h2>
                  <h4>Most check-in timeslot</h4>
                </div>
                <div>
                  <strong>
                    <h2>{{ hotCheckInSlot }}</h2>
                  </strong>
                </div>
              </div>
            </mat-grid-tile>
            <mat-grid-tile colspan="3">
              <div [ngClass]="{
                  'visitor-analytics-counter-values':
                    screenSize == ScreenType.Desktop ||
                    screenSize == ScreenType.Tablet,
                  'visitor-analytics-counter-values-mobile':
                    screenSize == ScreenType.Mobile
                }">
                <div>
                  <h2>{{ "Total Unchecked Out " | uppercase }}</h2>
                  <h4>Count of visitors pending checkout</h4>
                </div>
                <div>
                  <strong>
                    <h2>{{ currentDayVisitors }}</h2>
                  </strong>
                </div>
              </div>
            </mat-grid-tile>
          </mat-grid-list>
        </div>
      </mat-grid-tile><mat-grid-tile rowspan="3" *ngIf="!isDisableFeature">
        <div class="tile-div">
          <mat-card class="risk-charts-card"><mat-card-header [ngClass]="{
                'risk-counter-card-header':
                  screenSize == ScreenType.Desktop ||
                  screenSize == ScreenType.Tablet,
                'risk-counter-card-header-mobile':
                  screenSize == ScreenType.Mobile
              }">Day Risk Score</mat-card-header>
            <mat-card-content class="risk-charts-card-content">
              <app-risk-bar-graph *ngIf="riskSingleData?.length > 0" [chartHeight]="300"
                [chartData]="riskSingleData"></app-risk-bar-graph>
              <div *ngIf="riskSingleData?.length == 0" class="no-data-available">
                No Data Available
              </div>
            </mat-card-content>
          </mat-card>
        </div>
      </mat-grid-tile>
      <mat-grid-tile rowspan="3" *ngIf="isDisableFeature">
        <div class="tile-div">
          <mat-card class="risk-charts-card"><mat-card-header [ngClass]="{
                'risk-counter-card-header':
                  screenSize == ScreenType.Desktop ||
                  screenSize == ScreenType.Tablet,
                'risk-counter-card-header-mobile':
                  screenSize == ScreenType.Mobile
              }">Visitor Category Breakdown
            </mat-card-header>
            <mat-card-content class="risk-charts-card-content">
              <app-visitor-category-pie [chartHeight]="300"
                [chartData]="monthlyVisitorCategory"></app-visitor-category-pie>
            </mat-card-content>
          </mat-card>
        </div>
      </mat-grid-tile>
      <mat-grid-tile rowspan="3" *ngIf="!isHide">
        <div class="tile-div">
          <mat-card class="risk-charts-card"><mat-card-header [ngClass]="{
                'risk-counter-card-header':
                  screenSize == ScreenType.Desktop ||
                  screenSize == ScreenType.Tablet,
                'risk-counter-card-header-mobile':
                  screenSize == ScreenType.Mobile
              }">Monthly Visitors</mat-card-header>
            <mat-card-content class="risk-charts-card-content">
              <app-visitor-bar-graph [chartHeight]="300" [chartData]="monthlyVisitorBarGraph"></app-visitor-bar-graph>
            </mat-card-content>
          </mat-card>
        </div>
      </mat-grid-tile>
    </mat-grid-list>
  </section> -->
<!--  <br />
  <mat-divider></mat-divider>
  <br /> -->
<!-- <section *ngIf="!isDisableFeature">
    <mat-grid-list cols="1" rowHeight="120px">
      <mat-grid-tile rowspan="6">
        <div class="tile-div">
          <mat-card class="risk-charts-card"><mat-card-header [ngClass]="{
                'risk-counter-card-header':
                  screenSize == ScreenType.Desktop ||
                  screenSize == ScreenType.Tablet,
                'risk-counter-card-header-mobile':
                  screenSize == ScreenType.Mobile
              }">Risk Heatmap</mat-card-header>
            <mat-card-content class="risk-charts-card-content">
              <app-incident-heat-map *ngIf="riskHeatMapData?.length != null"
                [heatMapAssetData]="riskHeatMapData"></app-incident-heat-map>
              <div *ngIf="riskHeatMapData?.length == null" class="no-data-available">
                No Data Available
              </div>
            </mat-card-content>
          </mat-card>
        </div>
      </mat-grid-tile>
      <mat-grid-tile rowspan="4">
        <div class="tile-div">
          <mat-card class="risk-charts-card"><mat-card-header [ngClass]="{
                'risk-counter-card-header':
                  screenSize == ScreenType.Desktop ||
                  screenSize == ScreenType.Tablet,
                'risk-counter-card-header-mobile':
                  screenSize == ScreenType.Mobile
              }">Risk Profile
            </mat-card-header>
            <mat-card-content class="risk-charts-card-content">
              <app-risk-line-graph *ngIf="
                  !(
                    (riskAnalyticsPreviousMonthGraph?.length == 0 ||
                      rishGraphData?.length == 0) &&
                    riskQuestions?.length == 0
                  )
                " [chartHeight]="385" [riskGraphData]="riskGraphData"></app-risk-line-graph>
              <div *ngIf="
                  (riskAnalyticsPreviousMonthGraph?.length == 0 ||
                    rishGraphData?.length == 0) &&
                  riskQuestions?.length == 0
                " class="no-data-available">
                No Data Available
              </div>
            </mat-card-content>
          </mat-card>
        </div>
      </mat-grid-tile>
    </mat-grid-list>
  </section> -->
<!--  <br />
  <mat-divider></mat-divider>
  <br />
  <section *ngIf="!isDisableFeature">
    <mat-grid-list cols="1" rowHeight="120px">
      <mat-grid-tile rowspan="4">
        <div class="tile-div">
          <mat-card class="risk-charts-card"><mat-card-header [ngClass]="{
                'risk-counter-card-header':
                  screenSize == ScreenType.Desktop ||
                  screenSize == ScreenType.Tablet,
                'risk-counter-card-header-mobile':
                  screenSize == ScreenType.Mobile
              }">Risk Status Data
            </mat-card-header>
            <mat-card-content class="risk-charts-card-content">
              <app-risk-breakdown-graph *ngIf="riskAnalyticsStatusGraph?.length != null" [chartHeight]="385"
                [breakdownRiskData]="riskAnalyticsStatusGraph"></app-risk-breakdown-graph>
              <div *ngIf="riskAnalyticsStatusGraph?.length == null" class="no-data-available">
                No Data Available
              </div>
            </mat-card-content>
          </mat-card>
        </div>
      </mat-grid-tile>
    </mat-grid-list>
    <br />
    <mat-divider></mat-divider>
    <br />
  </section> -->

<!-- <section *ngIf="!isHide">
    <mat-grid-list cols="1" rowHeight="120px">
      <mat-grid-tile rowspan="3">
        <div class="tile-div">
          <mat-card class="risk-charts-card"><mat-card-header [ngClass]="{
                'risk-counter-card-header':
                  screenSize == ScreenType.Desktop ||
                  screenSize == ScreenType.Tablet,
                'risk-counter-card-header-mobile':
                  screenSize == ScreenType.Mobile
              }">Inbound/Outbound Bandwidth</mat-card-header>
            <mat-card-content class="risk-charts-card-content">
              <app-visitor-in-out-bound [chartHeight]="285"
                [visitorInOutGraphDetails]="monthlyVisitorInOutGraph"></app-visitor-in-out-bound>
            </mat-card-content>
          </mat-card>
        </div>
      </mat-grid-tile>
    </mat-grid-list>
  </section> -->
<!-- <mat-divider></mat-divider> -->
<!-- <section *ngIf="!isDisableFeature">
    <mat-grid-list [cols]="screenSize == ScreenType.Mobile ? 1 : 2" rowHeight="120px"><mat-grid-tile rowspan="3">
        <div class="tile-div">
          <mat-card class="risk-charts-card"><mat-card-header [ngClass]="{
                'risk-counter-card-header':
                  screenSize == ScreenType.Desktop ||
                  screenSize == ScreenType.Tablet,
                'risk-counter-card-header-mobile':
                  screenSize == ScreenType.Mobile
              }">Risk Score Breakdown
            </mat-card-header>
            <mat-card-content class="risk-charts-card-content">
              <app-risk-pie-graph [chartHeight]="300" [chartData]="criticalIncidentsData"></app-risk-pie-graph>
            </mat-card-content>
          </mat-card>
        </div>
      </mat-grid-tile>
      <mat-grid-tile rowspan="3">
        <div class="tile-div">
          <mat-card class="risk-charts-card"><mat-card-header [ngClass]="{
                'risk-counter-card-header':
                  screenSize == ScreenType.Desktop ||
                  screenSize == ScreenType.Tablet,
                'risk-counter-card-header-mobile':
                  screenSize == ScreenType.Mobile
              }">Visitor Category Breakdown
            </mat-card-header>
            <mat-card-content class="risk-charts-card-content">
              <app-visitor-category-pie [chartHeight]="300"
                [chartData]="monthlyVisitorCategory"></app-visitor-category-pie>
            </mat-card-content>
          </mat-card>
        </div>
      </mat-grid-tile>
    </mat-grid-list>
  </section> -->
<!-- </div> -->